module.exports = __webpack_public_path__ + "img/ozi_logo_white.0a76af58.svg";